import React, { useRef, useEffect } from 'react';
import PropTypes from "prop-types";
import { GdkModal } from "@gdk/modal";

export default function DeleteEmailModal({
    emailAddress = '',
    showModal = false,
    setShowModal = () => { },
    onConfirm = () => { },
    isLoading = false,
    modalId = ''
}) {
    const gdkModal = useRef(null);

    useEffect(() => {
        if (modalId) {
            gdkModal.current = new GdkModal({
                content: "#" + modalId,
                hideCloseButton: false,
                onClosed: () => {
                    setShowModal(false);
                },
            });
        }
    }, [setShowModal]);

    useEffect(() => {
        if (showModal === true && gdkModal.current?.show) {
            gdkModal.current.show();
        }

        if (showModal === false && gdkModal.current?.hide) {
            gdkModal.current.hide();
        }
    }, [showModal]);

    const handleDeleteClick = () => {
        onConfirm();
    };

    return (
        <div id={modalId} className="modal">
            <div className="modal-container">
                <h2 className="modal-headline">Delete Email</h2>
                <div className="full-width-line" />
                <div className="modal-content modal-content-with-cta-bar">
                    If you continue, the email address {emailAddress} will be removed. You can add this email to your account again later.
                </div>
                <div className="modal-content">
                    <div className="modal--call-to-action-bar">
                        <button
                            type="button"
                            className="btn btn--primary btn--full-mobile btn--pull-right"
                            onClick={handleDeleteClick}
                            data-testid="modal-delete-email-button"
                            disabled={isLoading}
                        >
                            <span>Continue</span>
                        </button>
                        <button
                            type="button"
                            className="btn btn--destructive btn--full-mobile btn--pull-right"
                            data-testid="modal-cancel-delete-email-button"
                            onClick={() => setShowModal(false)}
                            disabled={isLoading}
                        >
                            <span>Cancel</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

DeleteEmailModal.propTypes = {
    emailAddress: PropTypes.string,
    showModal: PropTypes.bool,
    setShowModal: PropTypes.func,
    onConfirm: PropTypes.func,
    isLoading: PropTypes.bool,
    modalId: PropTypes.string
};
